import {Trans} from '@lingui/macro';
import React, {FC} from 'react';
import styled from 'styled-components';

import {HandlerOf} from '../../../../libs/shared/helpers/src/react/reactHelpers';
import {DropdownItem} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItem';
import {DropdownItemCheckbox} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemCheckbox';
import {DropdownItemContent} from '../../../../libs/shared/ui/src/components/dropdowns/dropdownItemContent';
import {fontSizes, fontWeights} from '../../../../libs/shared/ui/src/styles/fontStyles';
import {DropdownItemIcon} from '../../../components/common/dropdowns/dropdownItemIcon';
import {ChannelModel} from '../../../models/api/channelModel';
import {
  SignaturesChannelDropdownInheritableProps,
  SignaturesChannelDropdownProps,
} from './signaturesChannelDropdown';

/*
 * Props.
 */

type SignaturesChannelDropdownContentProps = Omit<SignaturesChannelDropdownInheritableProps, 'inputItems'> & {
  onChange: HandlerOf<ChannelModel>;
  serializeItemForSearch: SignaturesChannelDropdownProps['serializeItemForSearch'];
};

/*
 * Style.
 */

const StyledDropdownContentTitle = styled(DropdownItemContent)`
  font-size: ${fontSizes.verySmall};
  color: ${(p) => p.theme.greys.shade60};
  font-weight: ${fontWeights.semibold};

  &:hover {
    background: none;
  }
`;

/*
 * Component.
 */

export const SignaturesChannelDropdownContent: FC<SignaturesChannelDropdownContentProps> = (props) => {
  const {selectedItems, onChange} = props;

  return (
    <>
      <DropdownItem key={`title-${props.getItemKey(props.items[0])}`} isNotInteractive>
        <StyledDropdownContentTitle>
          <Trans id="signature-channels-list-title">Channels</Trans>
        </StyledDropdownContentTitle>
      </DropdownItem>
      {props.items.map((item) => {
        const isChecked = Boolean(selectedItems?.includes(item));

        return (
          <DropdownItem
            key={props.getItemKey(item)}
            renderRightContent={() => <DropdownItemCheckbox isChecked={isChecked} />}
            isChecked={isChecked}
            onSelect={() => onChange(item)}
          >
            {props.renderItemIcon ? (
              <DropdownItemIcon label={props.renderItemLabel(item)}>
                {props.renderItemIcon(item)}
              </DropdownItemIcon>
            ) : null}
            <DropdownItemContent isChecked={isChecked}>{props.renderItemLabel(item)}</DropdownItemContent>
          </DropdownItem>
        );
      })}
    </>
  );
};
